export default "/images/fbe3e3ec86574e7bcfe529381063ca84.avif";